import { VisitorType } from 'generated/mos/org/getty/audio'
import { TranslatableStringValue } from 'generated/mos/translatable'

import { Schema } from 'helpers/schema'
import { getTranslatableValue, setTranslatableValue, createTranslatableStringValue, } from 'helpers/translatables'

const isNonEmpty = (value: any) => {
  if (typeof value === 'string' && (!value || !value.trim().length) || typeof value === 'object' && !Object.keys(value).length) {
    return false
  }

  return value
}

export const visitorTypeSchema: Schema<VisitorType.Entity> = {
  label: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  tag: {
    read: value => value ? value as any : undefined,
    write: value => isNonEmpty(value) ? value as any : undefined,
  },
}
